import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Form from "./Form";

import { useTopicContext } from "../../../../contexts/TopicContext";

export default function ModalForm() {
  const { dispatch, actions, state } = useTopicContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showModal}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Topic</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </>
  );
}
